/* eslint-disable prettier/prettier -- behoud de afgesproken witregels binnen conditionals. */
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { createAbortError, fetchAssetBuffer, fetchAssetText } from './assetRequests'

const decoderPath = 'https://3dassets.royalbotania.com/decoders/three-r163/'

export class ModelDRACOLoader extends DRACOLoader {
  constructor(signal) {
    super()

    this.controller = new AbortController()
    this.signal = this.controller.signal
    this.parentSignal = signal
    this.handleAbort = () => this.controller.abort()
    this.closed = false
    this.pendingDecodes = new Set()

    signal?.addEventListener('abort', this.handleAbort, { once: true })

    if (signal?.aborted) {

      this.handleAbort()

    }

    // een decoder per model voorkomt dat een unmount een andere viewer onderbreekt.
    this.setDecoderPath(decoderPath)
    this.setWorkerLimit(1)
  }

  _loadLibrary(file, responseType) {
    // three r163 gebruikt hier standaard FileLoader zonder AbortSignal.
    const fetchLibrary = responseType === 'arraybuffer' ? fetchAssetBuffer : fetchAssetText

    return fetchLibrary(new URL(file, this.decoderPath).href, this.signal)
  }

  preload() {
    // de GLTFLoader start deze promise vooraf; de meshdecode geeft fouten door aan de parser.
    this._initDecoder().catch(() => {})

    return this
  }

  decodeGeometry(buffer, configuration) {
    if (this.closed || this.signal?.aborted) {

      return Promise.reject(createAbortError())

    }

    const pending = super.decodeGeometry(buffer, configuration)

    this.pendingDecodes.add(pending)

    const settled = () => this.pendingDecodes.delete(pending)

    pending.then(settled, settled)

    return pending
  }

  async release() {
    this.closed = true

    // een fout in één decoderbestand mag de andere download niet laten doorlopen.
    this.controller.abort()
    this.parentSignal?.removeEventListener('abort', this.handleAbort)

    // laat lokale decodejobs afronden: terminate() zou hun promises open laten staan.
    await Promise.allSettled([this.decoderPending, ...this.pendingDecodes])

    this.dispose()
  }
}
